export default __webpack_public_path__ + "static/media/img_cty1.8cb12141.png";